<template>
	<v-badge
		v-model:model-value="enabled"
		:content="content"
		color="secondary"
		bordered
	>
		<v-btn
			:elevation=" enabled ? '1' : '0'"
			:color="enabled ? 'secondary' : 'primary'"
			:disabled="!enabled"
			@click="checkout"
		>
			<v-icon icon="$basket" />
		</v-btn>
	</v-badge>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'ShoppingCartSymbol',

	data () {
		return {
			enabled: true,
			content: 0
		};
	},

	mounted () {
		this.checkForCurrentCheckoutProcess();
	},

	methods: {
		/**
		 * Check the session for a current checkout process
		 */
		checkForCurrentCheckoutProcess () {
			axios.get('/checkout/sessioninfo')
				.then((resp) => {
					this.enabled = !!resp.data;
					this.content = resp.data;
				})
				.catch((error) => {
					if(error.response && error.response.data) {
						displayError(this.$gettext(error.response.data));
					} else {
						displayError(this.$gettext('Something went wrong'));
						window.captureException(error);
					}
				});
		},

		/**
		 * Go to checkout
		 */
		checkout () {
			window.location.href = '/checkout';
		}
	}
};
</script>
